module.exports = __webpack_public_path__ + "static/img/moodle-logo.b873149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moodle-logo.svg
// module id = uuVl
// module chunks = 1